import { Theme, themeQuartz } from 'ag-grid-community';

// Central AG Grid Quartz theme with BMW DS palette
export const ICDQuartzTheme: Theme | 'legacy' = themeQuartz.withParams({
  headerBackgroundColor: 'var(--ds-color-cool-grey-500)',
  headerTextColor: '#0e0e0e',
  headerColumnBorder: { style: 'solid' },
  columnBorder: { style: 'solid' },
  foregroundColor: '#1a1a1a',
  backgroundColor: '#ffffff',
  rowHoverColor: 'var(--ds-color-cool-grey-300)',
  selectedRowBackgroundColor: 'var(--ds-color-blue-400)',
  oddRowBackgroundColor: 'var(--ds-color-cool-grey-100)',
  columnHoverColor: 'rgba(95, 142, 192, 0.08)',
});

export type ICDThemeType = typeof ICDQuartzTheme;
